import {adminHttpClient} from "../../../commons/adminHttpClinet";
import {MarketplaceProgramReserve} from "../../../models/dashboard/marketplacePurchase/marketplacePurchaseModel";

const getMarketplaceProgramReserve = ():Promise<MarketplaceProgramReserve> => {
    return adminHttpClient.get('/api/Admin/AdminStatistics/marketplace-reserve');
};

export default getMarketplaceProgramReserve;